export enum CompanyTradingDtoProp {
  Latest = 'latest',
  FirstDayReturn = 'firstDayReturn',
  ReturnFromIpo = 'returnFromIpo',
  AftermarketReturn = 'aftermarketReturn',
}
